<template>
	<div id="" style="height: 100vh;">
		<iframe :src="$route.query.url" width="100%" height="100%"></iframe>
	</div>
</template>

<script>
	
	export default {
		name: "livevideo",
		components: {
			
		},
		data(){
			return{
				
			}
		},
		methods:{},
		mounted(){
		}
	}
</script>

<style scoped>
	
    
</style>